import { makeStyles } from "@mui/styles";

const cardStyle = makeStyles((theme) => ({
  serviceCard: {
    backgroundColor: " #fff",
    padding: "40px",
    borderRadius: "10px",
    position: "relative",
    cursor: "pointer ",
    
    "&.MuiBox-root .MuiTypography-h4": {
        fontSize: "22px !important",
        fontWeight: "700 !important",
        margin: "30px 0px !important",
        display: "inline-block !important",
        borderBottom: "4px solid #eeeeee",
        paddingBottom: "8px",
        transition: "0.5s",
    },

    "&.MuiBox-root .MuiButton-root": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "transparent",
      border: "none",
      fontSize: "16px !important",
      textTransform: "capitalize !important",
      color: "#008374",
      padding: "0px !important",
    },
    "&.MuiBox-root .cardCircle": {
      backgroundColor: "#eeeeee",
      height: "50px",
      width: "50px",
      borderRadius: "50%",
      position: "relative",
      left: "20px",
      transition: "0.5s",
    },
    "&:hover": {
      "&.MuiBox-root .MuiTypography-h4": {
        borderBottom: "4px solid #00b6a1",
      },
      "&.MuiBox-root .cardCircle":{
        backgroundColor:"#00b6a1"
      }
    },
  },
}));

export default cardStyle;
